<template>
    <div>
        <FormKit
            type="hidden"
            :name="`components[${index}][component_type]`"
            :value="component.component_type"
        />

        <FormKit
            label="Titel"
            type="text"
            :name="`components[${index}][title]`"
            :value="modelValue.title"
            @input="(value) => update('title', value)"
        />

        <FormKit
            label="Gebruik grote titel"
            type="checkbox"
            :name="`components[${index}][use_big_title]`"
            :value="!!modelValue.use_big_title"
            @input="(value) => update('use_big_title', value)"
        />

        <div class="form-group">
            <FormKitCKEditor
                label="Omschrijving"
                :name="`components[${index}][description]`"
                :modelValue="modelValue.description ?? ''"
                @input="(value) => update('description', value)"
            />
        </div>

        <FormKit
            label="Als slider"
            type="checkbox"
            :name="`components[${index}][is_slider]`"
            :value="!!modelValue.is_slider"
            @input="(value) => update('is_slider', value)"
            hint="Als het geen slider is, wordt er een grid laten zien."
        />

        <FormKit
            label="Gebruik kleine afbeeldingen"
            type="checkbox"
            :name="`components[${index}][use_small_images]`"
            :value="!!modelValue.use_small_images"
            @input="(value) => update('use_small_images', value)"
            hint="Gebruik minder hoge afbeeldingen zodat er een compactere layout ontstaat"
        />

        <label>
            Geselecteerde huizen

        <Draggable v-model="selectedMaisons" group="maisons">
            <template #item="{ element }" >
                <div class="multiselect__tag">
                    <span v-html="getLabel(element)" />
                    <i tabindex="1" class="multiselect__tag-icon" @click="remove(element)" />
                </div>
            </template>
        </Draggable>

        <VSelect
            multiple
            :options="maisons"
            v-model="selectedMaisons"
            :reduce="(maison) => maison.value"
        >
            <template #search="{ attributes, events }">
                <input
                    label="Champagnehuizen"
                    :name="`components[${index}][maisons]`"
                    v-on="events"
                    v-bind="attributes"
                    @change="test"
                    style="border: none"
                />
            </template>

            <template #selected-option-container>
                <div />
            </template>
        </VSelect>
        </label>

        <FormKit
            type="hidden"
            v-for="(id, maisonIndex) in component.maisons"
            :key="id"
            :value="id"
            :name="`components[${index}][maisons][${maisonIndex}]`"
        />

        <FormKit
            type="text"
            label="Knop label"
            @input="(value) => update('title', value)"
            :value="component.button_label"
            :name="`components[${index}][button_label]`"
        />

        <FormKit
            type="text"
            label="Knop link"
            @input="(value) => update('button_href', value)"
            :value="component.button_href"
            :name="`components[${index}][button_href]`"
        />
    </div>
</template>

<script>
import mixin from "../mixins/component";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";

export default {
    name: "PageMaisons",
    mixins: [mixin],
    async created() {
        this.component.maisons = Object.values(this.modelValue.maisons ?? []);

        const {
            data: { data: maisons },
        } = await axios.get("/admin/api/maisons?limit=1500");

        this.maisons = maisons.map((maison) => ({
            label: maison.name,
            value: maison.id,
        }));
    },
    data() {
        return {
            editor: ClassicEditor,
            editorData: "<p>Content of the editor.</p>",
            editorConfig: {
                // The configuration of the editor.
            },
            maisons: [],
            selectedMaisons: [
                ...(Object.values(this.modelValue?.maisons ?? []).map((id) =>
                    Number(id)
                ) ?? []),
            ],
        };
    },
    methods: {
        getLabel(id) {
            return _.find(this.maisons, { 'value': id })?.label ?? ""
        },
        remove(id) {
            this.selectedMaisons = _.filter(this.selectedMaisons, (maison) => maison !== id);
        }
    },
    watch: {
        selectedMaisons() {
            this.component.maisons = [...this.selectedMaisons];
        },
    },
};
</script>
